module.exports = __webpack_public_path__ + "img/second-onboarding-1.5d7518d6.png";